import { useToastContext } from "../layout/toastProvide";

export const useToast = () => {
  return useToastContext();
};
